<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { NuxtLink } from '#components';
const { $scrollToHash } = useNuxtApp();

const props = defineProps<{
  title: string;
  to?: string;
  url?: string;
  href?: string;
  icon?: string;
  target?: string;
  type?: 'button' | 'submit' | 'reset';
}>();

const isExternal = computed(() => !!props.href && !props.href.startsWith('#'));
const isHash = computed(() => props.href?.startsWith('#'));
const isButton = computed(
  () =>
    props.type === 'button' || props.type === 'submit' || props.type === 'reset'
);

const handleClick = (event: Event) => {
  const target = event.target as HTMLElement;
  const parentElement = target.closest('a, nuxt-link, button') as HTMLElement;
  const linkHref =
    parentElement?.getAttribute('href') || parentElement?.getAttribute('to');

  if (linkHref && linkHref.startsWith('#')) {
    event.preventDefault();

    history.replaceState(null, '', linkHref);

    $scrollToHash(linkHref);
  }
};
</script>

<template>
  <component
    :is="isExternal ? 'a' : isButton || isHash ? 'button' : NuxtLink"
    :href="isExternal ? href : undefined"
    :to="!isExternal && !isButton && !isHash ? to || url : undefined"
    :type="isButton ? type : undefined"
    :target="target ? target : undefined"
    :rel="target === '_blank' ? 'noopener noreferrer' : undefined"
    class="group inline-flex items-center font-mono text-xxl uppercase tracking-wide underline decoration-dotted decoration-1 underline-offset-5 transition-all duration-300 hover:text-blue hover:no-underline md:text-lg"
    @click="handleClick"
  >
    <span>{{ title }}</span>
    <svg
      v-if="icon"
      class="ml-2 block h-4 w-3 transition-transform duration-300 group-hover:translate-x-1"
    >
      <use :href="`/icons/icons.svg#${icon}`" />
    </svg>
  </component>
</template>
